import type { ReasonOption } from './data.js';

/**
 * Definitions PARTAGEES entre l'ecran Cat Logger Outside et son ecran de
 * reglages (settings.tsx, monte par le hub Parametres du shell) : catalogue
 * des stats d'en-tete, cles de prefs et valeurs par defaut. Un seul endroit,
 * zero duplication.
 *
 * Les prefs sont locales au poste (localStorage via readPref/usePref de
 * @taki/ui) et suivent les cles standard du socle :
 *  - "app.cat-logger-outside.stats"   : string[] (ids ordonnes des stats, max 3) ;
 *  - "app.cat-logger-outside.reasons" : ReasonOption[] (motifs ajoutes ici).
 *
 * Pastilles de filtre (zone 4) : cette app n'en a PAS. Les onglets Au refuge /
 * En sortie segmentent deja les donnees et la recherche est libre : il n'y a
 * rien a masquer. La cle standard "app.cat-logger-outside.filters"
 * (Record<filterId, boolean>, cle absente = visible) reste le slot reserve si
 * des pastilles apparaissent un jour ; settings.tsx affichera alors les coches.
 */

/* ---- Stats d'en-tete (zone 3) -------------------------------------------- */

/** Nombre maximal de stats affichees (contrat de la cle "app.<id>.stats"). */
export const STATS_MAX = 3;

/** Ids des statistiques disponibles pour l'annexe d'en-tete (zone 3). */
export type OutingStatId = 'inside' | 'outside' | 'overdue';

/**
 * Catalogue des stats affichables en haut a droite. La SELECTION (max 3) est
 * editable dans settings.tsx ; l'ordre d'affichage suit ce catalogue et les
 * valeurs restent calculees des donnees reelles par l'ecran.
 */
export const STAT_DEFS: ReadonlyArray<{ id: OutingStatId; label: string }> = [
  { id: 'inside', label: 'au refuge' },
  { id: 'outside', label: 'en sortie' },
  { id: 'overdue', label: 'en retard' },
];

/** Cle de pref : ids ordonnes des stats affichees. */
export const STATS_PREF_KEY = 'app.cat-logger-outside.stats';

/** Defaut stats : les 3 premieres du catalogue. */
export const DEFAULT_STATS: string[] = STAT_DEFS.slice(0, STATS_MAX).map((def) => def.id);

/* ---- Motifs de sortie (reglage metier de l'app) --------------------------- */

/**
 * Cle de pref : motifs de sortie AJOUTES dans les reglages, en plus de ceux
 * livres avec l'app (DEFAULT_REASONS de data.ts). Reprend le reglage qui
 * vivait dans l'ancien ecran Parametres du gabarit, en MIEUX : porte par une
 * pref, un motif ajoute survit desormais a la session (il etait perdu au
 * rechargement). Des qu'une sortie l'emploie, il est AUSSI relu depuis les
 * donnees (cf. `reasons` de l'ecran) et devient visible sur tous les postes.
 */
export const REASONS_PREF_KEY = 'app.cat-logger-outside.reasons';

/** Defaut motifs ajoutes : aucun. */
export const DEFAULT_CUSTOM_REASONS: ReasonOption[] = [];
